import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'message-cta',
    templateUrl: './message-cta.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageCtaComponent {
    public readonly buttonLink = input.required<string>();
    public readonly buttonText = input.required<string>();
}
